module.exports = __webpack_public_path__ + "img/service_diagnose.e9c2dc99.svg";